'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { capitalize } from 'lodash-es';
import AssetFilterBase from '@/components/common/TableAdvancedFilters/AssetFilter';
import type { CuratorAssetOptions } from '../config/curatorAssetOptions';
import { getCuratorAssetSelector } from '../hooks/useCuratorVaultsTableFilters';
interface AssetFilterProps {
  label: string;
  options: CuratorAssetOptions;
  assets: string[];
  chainIds?: ChainId[];
  onAssetsChange: (assets: string[]) => void;
  disabled: boolean;
  hasHighestZIndex?: boolean;
  onClear?: () => void;
}
const AssetFilter = t0 => {
  const $ = _c(24);
  const {
    label,
    options,
    assets,
    chainIds,
    disabled,
    hasHighestZIndex,
    onAssetsChange,
    onClear
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = capitalize(label);
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-3xs text-foreground">{t1}:</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== options?.items) {
    t3 = options?.items ?? [];
    $[4] = options?.items;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = disabled || options === null && assets.length === 0;
  let t5;
  if ($[6] !== assets || $[7] !== chainIds || $[8] !== hasHighestZIndex || $[9] !== label || $[10] !== onAssetsChange || $[11] !== onClear || $[12] !== t3 || $[13] !== t4) {
    t5 = <AssetFilterBase label={label} allAssets={t3} assets={assets} chainIds={chainIds} onAssetsChange={onAssetsChange} disabled={t4} hasHighestZIndex={hasHighestZIndex} onClear={onClear} getAssetSelector={getCuratorAssetSelector} />;
    $[6] = assets;
    $[7] = chainIds;
    $[8] = hasHighestZIndex;
    $[9] = label;
    $[10] = onAssetsChange;
    $[11] = onClear;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== options) {
    t6 = options === null && <span className="text-3xs text-secondary-foreground" data-testid="curator-asset-filter-unavailable">Assets unavailable</span>;
    $[15] = options;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== options?.partial) {
    t7 = options?.partial && <span className="text-3xs text-secondary-foreground" data-testid="curator-asset-filter-partial">Some assets could not be loaded</span>;
    $[17] = options?.partial;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t2 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className="gap-xs flex items-center" data-testid="curator-asset-filter">{t2}{t5}{t6}{t7}</div>;
    $[19] = t2;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default AssetFilter;